import React from 'react';

import Stack from '@mui/material/Stack';

import GuideInfoBox from '../components/GuideInfoBox';
import GuideMockButton from '../components/GuideMockButton';
import GuideMockContainer from '../components/GuideMockContainer';
import GuideMockTextField from '../components/GuideMockTextField';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideStepList from '../components/GuideStepList';
import GuideTable from '../components/GuideTable';

const GuideContractComment: React.FC = () => {
  return (
    <GuidePageLayout
      title="契約申請にコメントする"
      description="契約申請に関する質問・連絡をコメントで行います。"
      breadcrumbs={[{ label: '契約管理', path: '/guide/contract/overview' }]}
    >
      <GuideSection title="前提">
        <GuideTable
          headers={['条件', '内容']}
          rows={[
            ['必要な権限', '管理者 / 管理部門 / 課長'],
            ['ログイン状態', 'ログイン済みであること'],
          ]}
        />
      </GuideSection>

      <GuideSection title="手順">
        <GuideStepList
          steps={[
            { label: '契約詳細画面または契約申請詳細画面のコメントタブを開く' },
            {
              label: 'コメント入力欄にテキストを入力する',
              description: '返信の場合は既存コメントの「返信」ボタンを押下してから入力します。',
              content: (
                <GuideMockContainer label="コメント入力">
                  <Stack spacing={1}>
                    <GuideMockTextField label="コメント" />
                    <GuideMockButton label="送信" size="small" />
                  </Stack>
                </GuideMockContainer>
              ),
            },
            { label: '「送信」ボタンを押下する' },
          ]}
        />
      </GuideSection>

      <GuideSection title="入力項目">
        <GuideTable
          headers={['項目名', '必須', '形式', '備考']}
          rows={[['コメント', '必須', 'テキスト（最大3000桁）', '']]}
        />
      </GuideSection>

      <GuideSection title="注意事項">
        <Stack spacing={1}>
          <GuideInfoBox>コメントはスレッド形式で表示されます（親コメントへの返信）。</GuideInfoBox>
          <GuideInfoBox>
            契約画面から投稿したコメントと申請画面から投稿したコメントは同じスレッドに統合表示されます。
          </GuideInfoBox>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideContractComment;
